export { SearchStoreCard, type SearchStoreCardProps } from './SearchStoreCard';
